export const ACTUALIZAR_LIST_NIVEL5 = "ACTUALIZAR_LIST_NIVEL5";
export const MODIFICAR_NIVEL5 = "MODIFICAR_NIVEL5";
export const AGREGAR_NIVEL5 = "AGREGAR_NIVEL5";  
export const ELIMINAR_NIVEL5 = "ELIMINAR_NIVEL5";